import { formatEventTime } from "@notemeal/utils-date-time";
export const formatMeal = (meal) => {
    return `${meal.name} (${formatEventTime(meal)})`;
};
export const orderedMealTypes = ["breakfast", "lunch", "dinner", "snack"];
//# sourceMappingURL=utils.js.map